import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"
import { themeChange } from 'theme-change'
import "bridgetown-quick-search"

import "bridgetown-quick-search/dist"
import "./timeago"





